import React from 'react';
import './ProblemSection.scss';

const CHALLENGES = [
  {
    id: 'suivi',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 12a9 9 0 0 1 15-6.7M21 12a9 9 0 0 1-15 6.7"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 4v3.5h-3.5M7 20v-3.5h3.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: 'Suivi fragmenté',
    text: "Entre orientation, sélection et formation, l'information se perd à chaque étape.",
  },
  {
    id: 'visibilite',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 3l18 18"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6 5.1A10.9 10.9 0 0 1 12 5c6 0 9.5 5.5 9.5 7 0 .7-.8 2.2-2.3 3.6M6.6 6.6C4.2 8.1 2.8 10.4 2.5 11c-.1.2-.1.4 0 .6.5 1 3.8 6.4 9.5 6.4 1.4 0 2.7-.3 3.8-.9"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1 14.1a3 3 0 0 1-4.2-4.2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: 'Manque de visibilité',
    text: 'Sur les places disponibles et les profils des candidates.',
  },
  {
    id: 'reporting',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 20V11M12 20V4M19 20v-7"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: 'Reporting difficile',
    text: "Mesurer l'impact réel des formations reste un défi.",
  },
];

const ProblemSection = () => {
  return (
    <div className="unfm-ecosystem">
      <section className="ecosystem">
        <div className="ecosystem__container">
          <h2 className="ecosystem__title">
            Un écosystème encore trop cloisonné
          </h2>

          <p className="ecosystem__subtitle">
            L&apos;orientation d&apos;une femme vers une formation
            professionnelle implique aujourd&apos;hui plusieurs acteurs —
            assistants sociaux, associations, centres de formation — qui
            travaillent souvent de façon dispersée, avec une visibilité
            limitée sur le parcours réel de chaque candidate.
          </p>

          <div className="ecosystem__grid">
            {CHALLENGES.map((item) => (
              <div className="ecosystem__card" key={item.id}>
                <span className="ecosystem__card-icon">{item.icon}</span>
                <h3 className="ecosystem__card-title">{item.title}</h3>
                <p className="ecosystem__card-text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProblemSection;